<template>
    <div class="perfil-picture-uploader">
        <picture-input
            ref="pictureInput"
            width="600"
            height="600"
            margin="16"
            accept="image/*"
            size="10"
            button-class="btn btn-primary"
            removeButtonClass="btn btn-black btn-borderless"
            radius="50"
            :crop="true"
            :prefill="photo"
            :hideChangeButton="false"
            :autoToggleAspectRatio="true"
            :toggleAspectRatio="true"
            :removable="false"
            :custom-strings="{
                upload: 'Cambiar',
                change: 'Cambiar',
                remove: 'Quitar',
                drag: 'Cambiar',
                select: 'Seleccionar', // Text only
                selected: '<p>Photo successfully selected!</p>', // HTML allowed
                fileSize: 'The file size exceeds the limit', // Text only
                fileType: 'This file type is not supported.', // Text only
                aspect: 'Landscape/Portrait' // Text only

            }"
            @change="onChange">
            </picture-input>
            <button
                v-if="didChange"
                @click="emitSave"
                class="btn btn-primary perfil-picture-uploader-save">
                Guardar
            </button>
    </div>

<!--

                    <div class="row">
                          <div class="col" >
                              <img :src="photo" class="img-responsive" height="70" width="90">
                           </div>
                          <div class="col">
                              <input type="file" v-on:change="onImageChange" class="form-control">
                          </div>
                          <div class="col">
                             <button class="btn btn-success btn-block" @click="uploadImage">Upload Image</button>
                          </div>
                       </div>

                       -->

</template>

<script>
import PictureInput from "vue-picture-input";
import defaultPhoto from "@/assets/images/default-user-icon.png";

export default {
	components: {
		PictureInput
	},
	computed: {
		photo() {
			return this.prefill ? this.prefill : defaultPhoto;
		}
	},
	props: ["prefill"],
	data() {
		return {
			didChange: false,
			file: null
		};
	},
	methods: {
		onChange() {
			this.didChange = true;
			this.file = this.$refs.pictureInput.$refs.fileInput.files[0];
		},
		onImageChange(e) {
			let files = e.target.files || e.dataTransfer.files;
			if (!files.length) {
				return;
			}
			let formData = new FormData();
			formData.append("file", files[0]);
			this.createImage(files[0]);
			this.uploadImage(formData);
		},
		createImage(file) {
			let reader = new FileReader();
			let vm = this;
			reader.onload = e => {
				vm.file = e.target.result;
			};
			reader.readAsDataURL(file);
		},
		emitSave() {
            this.$emit("updateUserPhoto", this.file);
            this.didChange = false
		}
	}
};
</script>
